import { Sistema } from './../_classes/sistema';
import { tap } from 'rxjs/operators';
import { take, catchError } from 'rxjs/operators';
import { AvaliacaoSistema } from './../_classes/avaliacao-sistema';
import { Subject, EMPTY } from 'rxjs';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Servidor } from '../_classes/servidor';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Usuario } from '../_classes/usuario';
import { MensagemService } from '../_servicos/mensagem.service';
import { Mensagem } from '../_classes/mensagem';
import { TipoMensagem } from '../_classes/enum/tipo_mensagem';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-ratting2',
  templateUrl: './ratting2.component.html',
  styleUrls: ['./ratting2.component.scss'],
})
export class Ratting2Component implements OnInit {
  carregando = false;
  servidor$: Observable<Servidor>;
  servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  mensagem: string = 'Sua opinião é muito importante!';

  avaliacao: AvaliacaoSistema = null;
  dataSource$: Observable<AvaliacaoSistema>;
  dataSourceMG$: Observable<string>;

  mediaGeral: string;

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private msgService: MensagemService,
    private alertService: ModalAlertaService,
    private env: EnvService
  ) {
    //console.log('constructor  - rating component');
    this.atualizar();
  }

  ngOnInit() {}

  executarAoCarregarDatasource(x) {
    //console.log('busquei informação de avaliação');
    //console.log(x);
    //console.log('valores individuais');
    if (x) {
      x.forEach((a) => {
        //console.log('a');
        //console.log(a);
        this.avaliacao = new AvaliacaoSistema(a);
        ////console.log('this.avaliacao');
        ////console.log(this.avaliacao);
      });
    }
    this.carregando = false;
  }

  executarAoCarregarServidor(x) {
    this.servidor = new Servidor(x);
    this.carregando = false;
  }

  handleError(e: any) {
    //console.log(e);
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }

  mediaGeralAtualizar() {
    this.dataSourceMG$ = this.service.getMediaGeral().pipe(take(1));

    this.dataSourceMG$.subscribe(
      (a) => (this.mediaGeral = a),
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
  }

  atualizar() {
    this.carregando = true;
    /*const source = timer(10000);
    const subscribe = source.subscribe(v => {
      this.carregando = false;
    });*/
    this.mediaGeralAtualizar();
    this.servidor = this.env.servidor;
    /*
    if (!this.avaliacao) {
      //console.log("!this.avaliacao");
      this.avaliacao = new AvaliacaoSistema();
      this.avaliacao.sistema = new Sistema();
      this.avaliacao.sistema.codSist = 57;
      this.avaliacao.usuario = new Usuario(this.servidor.usuario);
      this.avaliacao.dtAvaliacao = new Date();
      this.avaliacao.snAtivo = "S";
      this.avaliacao.nrAvaliacao = 0;
    }*/

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );

    this.carregando = true;

    if (this.servidor) {
      this.carregando = true;
      if (this.servidor) {
        this.dataSource$ = this.service
          .getAvaliacaoSistema(this.servidor.idServidor)
          .pipe(take(1));
        //console.log('buscar avaliacoes');
        this.dataSource$.subscribe(
          (a: AvaliacaoSistema) => {
            this.executarAoCarregarDatasource(a);
          },
          (e) => {
            this.handleError(e);
            return EMPTY;
          }
        );
      }
    }
    this.carregando = false;
  }

  onClick(r: number): void {
    //console.log('onclick ');
    let a: AvaliacaoSistema = new AvaliacaoSistema(this.avaliacao);
    ////console.log('a');
    ////console.log(a);
    ////console.log('this.avaliacao');
    ////console.log(this.avaliacao);
    if (a.nrAvaliacao !== r) {
      a.nrAvaliacao = r;
    } else {
      a.nrAvaliacao = 0;
    }

    a.sistema = new Sistema();
    a.sistema.idSistema = 57;

    a.usuario = new Usuario(this.servidor.usuario);

    this.service.setAvaliacaoSistema(a).subscribe(
      (x) => {
        //console.log('votei ');
        //console.log(r);
        this.atualizar();
        let m: Mensagem = new Mensagem();
        m.mensagem = 'Obrigado por sua avaliação';
        m.tipo = TipoMensagem.SUCESSO;
        this.msgService.registrarMensagem(m);
      },
      (e) => {
        this.mensagem = 'Erro, tente novamente';
        this.handleError(e);
        return EMPTY;
      }
    );
  }
}
